import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link } from 'react-router-dom';
import { storeAPI } from '../../services/api';
import { ShoppingBag, ChevronDown, Package, Sparkles } from 'lucide-react';

const AllCategories = () => {
  const [tree, setTree] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expanded, setExpanded] = useState({});

  useEffect(() => {
    storeAPI.getCategoryTree()
      .then(res => setTree(res.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const toggle = (id) => setExpanded(prev => ({ ...prev, [id]: !prev[id] }));

  return (
    <div className="max-w-7xl mx-auto px-4 py-8">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-900 dark:text-white">Todas las Categorías</h1>
        <p className="text-gray-500 dark:text-gray-400 mt-1">Explora nuestra jerarquía completa de productos</p>
      </div>
      {loading ? (
        <div className="flex justify-center py-20"><div className="animate-spin rounded-full h-12 w-12 border-b-2 border-orange-600" /></div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {tree.map((cat) => (
            <motion.div key={cat.id} initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}
              className={`bg-white dark:bg-gray-800 rounded-2xl border border-gray-100 dark:border-gray-700 overflow-hidden ${cat.subcategories?.length ? 'hover:shadow-lg transition-shadow' : 'hover:shadow-lg hover:border-orange-300 dark:hover:border-orange-700 transition-all'}`}
            >
              <div className="p-5">
                <div className="flex items-center gap-3 mb-3">
                  <div className="p-2.5 bg-orange-100 dark:bg-orange-900/50 rounded-xl">
                    <ShoppingBag className="w-5 h-5 text-orange-600" />
                  </div>
                  <div className="flex-1 min-w-0">
                    <Link to={`/store/categories/${cat.slug}`}
                      className="font-semibold text-gray-900 dark:text-white hover:text-orange-500 transition-colors block truncate"
                    >{cat.name}</Link>
                    <p className="text-xs text-gray-500 dark:text-gray-400">
                      {cat.is_physical ? 'Productos Físicos' : 'Digitales'}
                    </p>
                  </div>
                  {cat.subcategories?.length > 0 && (
                    <button onClick={() => toggle(cat.id)}
                      className="p-1.5 hover:bg-gray-100 dark:hover:bg-gray-700 rounded-lg transition-colors"
                    >
                      <ChevronDown className={`w-4 h-4 text-gray-400 transition-transform ${expanded[cat.id] ? 'rotate-180' : ''}`} />
                    </button>
                  )}
                </div>
                {cat.subcategories?.length > 0 && (
                  <AnimatePresence>
                    {expanded[cat.id] && (
                      <motion.div initial={{ height: 0, opacity: 0 }} animate={{ height: 'auto', opacity: 1 }} exit={{ height: 0, opacity: 0 }}
                        className="overflow-hidden"
                      >
                        <div className="ml-1 pl-4 border-l-2 border-orange-200 dark:border-orange-800 space-y-2 mt-2">
                          {cat.subcategories.map(sub => (
                            <div key={sub.id}>
                              <Link to={`/store/categories/${cat.slug}?subcategory=${sub.id}`}
                                className="block text-sm text-gray-600 dark:text-gray-300 hover:text-orange-600 py-1"
                              >{sub.name}</Link>
                              {sub.families?.length > 0 && (
                                <div className="ml-3 pl-3 border-l border-gray-200 dark:border-gray-600 space-y-1 mb-2">
                                  {sub.families.map(fam => (
                                    <Link key={fam.id} to={`/store/categories/${cat.slug}?family=${fam.id}`}
                                      className="block text-xs text-gray-400 dark:text-gray-500 hover:text-orange-500 py-0.5"
                                    >{fam.name}</Link>
                                  ))}
                                </div>
                              )}
                            </div>
                          ))}
                        </div>
                      </motion.div>
                    )}
                  </AnimatePresence>
                )}
              </div>
            </motion.div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AllCategories;
